import { render, staticRenderFns } from "./VmNotFound.vue?vue&type=template&id=059c07ca&"
import script from "./VmNotFound.vue?vue&type=script&lang=js&"
export * from "./VmNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports